/* ============================================================================
   ВКЛАДКИ CART DRAWER + ПРОМОКОД

   Тема перерисовывает весь #CartDrawer при любом изменении корзины
   (cart-drawer.js → renderContents), поэтому обработчики вешаются
   делегированно на document — они переживают перерисовку. Локальные
   слушатели на кнопках после первой же смены количества были бы потеряны.

   ВАЖНО про промокод: после применения кода перерисовываются только
   .cart-drawer__footer (итоги и скидки) и cart-drawer-items (позиции).
   Полная перерисовка #CartDrawer снесла бы смонтированный в вкладке
   «Доставка» виджет #nova-poshta вместе с выбранным отделением — виджет
   восстанавливает из атрибутов корзины только тип доставки, но не город
   и не отделение.
   ============================================================================ */
(function () {
  'use strict';

  var OPEN_CLASS = 'is-open';

  function t(key) {
    var strings = window.cartDrawerStrings || {};
    return strings[key] || '';
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function cartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update';
  }

  /* ---------------------------------------------------------------- вкладки */

  function allPanels() {
    return document.querySelectorAll('.cart-drawer__panel');
  }

  function closeAllPanels() {
    Array.prototype.forEach.call(allPanels(), function (panel) {
      panel.classList.remove(OPEN_CLASS);
      panel.setAttribute('aria-hidden', 'true');
    });
    syncDeliverySummary();
  }

  function openPanel(name) {
    var panel = document.querySelector('.cart-drawer__panel[data-cart-panel="' + name + '"]');
    if (!panel) return;

    closeAllPanels();
    panel.classList.add(OPEN_CLASS);
    panel.setAttribute('aria-hidden', 'false');

    /* Фокус — на первое поле вкладки. В «Доставке» это поле города виджета,
       в «Коментарі» — textarea. */
    var field = panel.querySelector('textarea, input:not([type="radio"]):not([type="hidden"])');
    if (field) {
      setTimeout(function () {
        try {
          field.focus({ preventScroll: true });
        } catch (e) {
          field.focus();
        }
      }, 220);
    }
  }

  function anyPanelOpen() {
    return !!document.querySelector('.cart-drawer__panel.' + OPEN_CLASS);
  }

  /* Краткое описание выбранной доставки под кнопкой «Доставка».
     Виджет «Нова пошта» не пишет город/отделение в атрибуты корзины
     (CART_ATTRS = ['_delivery_type']), поэтому значение читается прямо
     из его полей. */
  function syncDeliverySummary() {
    var target = document.querySelector('[data-delivery-summary]');
    if (!target) return;

    var widget = document.getElementById('nova-poshta');
    var summary = '';

    if (widget) {
      var checked = widget.querySelector('input[type="radio"][name="id"]:checked');
      var type = checked ? checked.getAttribute('data-type') : 'branch';
      var city = document.getElementById('city-search');
      var point =
        type === 'courier' ? document.getElementById('address-street') : document.getElementById('warehouse-search');

      var cityValue = city && city.value ? city.value.trim() : '';
      var pointValue = point && point.value ? point.value.trim() : '';

      if (cityValue && pointValue) summary = cityValue + ', ' + pointValue;
      else summary = cityValue || pointValue;
    }

    target.textContent = summary;

    var button = target.closest('.cart-drawer__option');
    if (button) button.setAttribute('data-filled', summary ? 'true' : 'false');
  }

  /* ------------------------------------------------------------- промокод */

  function setPromoMessage(text, state) {
    var box = document.querySelector('[data-cart-promo-message]');
    if (!box) return;
    box.textContent = text || '';
    if (state) box.setAttribute('data-state', state);
    else box.removeAttribute('data-state');
  }

  function getCart() {
    return fetch(cartUrl() + '.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  /* POST /cart/update.js { discount: "CODE" }.
     Несколько кодов — через запятую, пустая строка снимает все. */
  function updateDiscount(code) {
    return fetch(cartUpdateUrl() + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) {
      return r.json();
    });
  }

  function cartHasDiscount(cart) {
    if (!cart) return false;
    if (Array.isArray(cart.discount_codes) && cart.discount_codes.length) return true;
    if (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length) {
      return true;
    }
    return !!cart.total_discount;
  }

  /* Код принят? Если сервер вернул discount_codes — верим флагу applicable,
     он единственный различает «код не существует» и «код есть, но не
     подходит к этой корзине». Если поля нет — судим по факту скидки. */
  function discountAccepted(cart, code) {
    var wanted = code.toLowerCase();

    if (Array.isArray(cart.discount_codes)) {
      var entry = null;
      cart.discount_codes.forEach(function (item) {
        if (item && typeof item.code === 'string' && item.code.toLowerCase() === wanted) entry = item;
      });
      if (!entry) return false;
      return entry.applicable !== false;
    }

    return cartHasDiscount(cart);
  }

  /* Коды, реально действующие на корзину сейчас. Нужны, чтобы новый код
     их не затёр: параметр discount задаёт СПИСОК целиком, поэтому отправка
     одного кода снимает все остальные. */
  function applicableCodes(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return [];
    return cart.discount_codes
      .filter(function (item) {
        return item && typeof item.code === 'string' && item.applicable !== false;
      })
      .map(function (item) {
        return item.code;
      });
  }

  function sameCode(a, b) {
    return a.toLowerCase() === b.toLowerCase();
  }

  /* Точечная перерисовка: итоги и позиции. Вкладки и виджет не трогаем. */
  function refreshCartRegions() {
    return fetch(cartUrl() + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        var drawerHTML = sections['cart-drawer'];
        if (drawerHTML) {
          var doc = new DOMParser().parseFromString(drawerHTML, 'text/html');
          swap(doc, '.cart-drawer__footer');
          swap(doc, 'cart-drawer-items');
        }

        var bubbleHTML = sections['cart-icon-bubble'];
        if (bubbleHTML) {
          var bubbleDoc = new DOMParser().parseFromString(bubbleHTML, 'text/html');
          var bubbleSource = bubbleDoc.querySelector('.shopify-section') || bubbleDoc.body;
          var bubbleTarget = document.getElementById('cart-icon-bubble');
          if (bubbleTarget && bubbleSource) bubbleTarget.innerHTML = bubbleSource.innerHTML;
        }
      });
  }

  function swap(doc, selector) {
    var source = doc.querySelector(selector);
    var target = document.querySelector(selector);
    if (source && target) target.innerHTML = source.innerHTML;
  }

  function submitPromo(form) {
    var input = form.querySelector('[data-cart-promo-input]');
    var button = form.querySelector('[data-cart-promo-submit]');
    var code = input ? input.value.trim() : '';

    if (button) button.setAttribute('aria-busy', 'true');
    setPromoMessage('', null);

    var work = getCart().then(function (cart) {
      var existing = applicableCodes(cart);

      /* Пустое поле — либо снять действующие коды, либо подсказать, что вводить */
      if (!code) {
        if (!existing.length && !cartHasDiscount(cart)) {
          setPromoMessage(t('promoEmpty'), 'error');
          return null;
        }
        return updateDiscount('').then(function () {
          setPromoMessage(t('promoRemoved'), 'success');
          return refreshCartRegions();
        });
      }

      /* Такой код уже действует — повторно ничего не отправляем */
      var alreadyApplied = existing.some(function (item) {
        return sameCode(item, code);
      });
      if (alreadyApplied) {
        setPromoMessage(t('promoApplied'), 'success');
        if (input) input.value = '';
        return null;
      }

      return updateDiscount(existing.concat([code]).join(',')).then(function (updated) {
        if (discountAccepted(updated, code)) {
          setPromoMessage(t('promoApplied'), 'success');
          if (input) input.value = '';
          return refreshCartRegions();
        }

        /* Код не принят. Возвращаем корзину к тем кодам, что действовали до
           попытки — иначе опечатка снимала бы уже работающую скидку. */
        setPromoMessage(t('promoInvalid'), 'error');
        return updateDiscount(existing.join(',')).then(refreshCartRegions);
      });
    });

    return work
      .catch(function () {
        setPromoMessage(t('promoError'), 'error');
      })
      .then(function () {
        if (button) button.removeAttribute('aria-busy');
      });
  }

  /* ---------------------------------------------------------- обработчики */

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var opener = event.target.closest('[data-cart-panel-open]');
    if (opener) {
      event.preventDefault();
      openPanel(opener.getAttribute('data-cart-panel-open'));
      return;
    }

    var closer = event.target.closest('[data-cart-panel-close]');
    if (closer) {
      event.preventDefault();
      closeAllPanels();
    }
  });

  document.addEventListener('submit', function (event) {
    if (!event.target || !event.target.closest) return;

    var form = event.target.closest('[data-cart-promo]');
    if (!form) return;
    event.preventDefault();
    submitPromo(form);
  });

  /* Escape внутри открытой вкладки закрывает вкладку, а не весь дровер.
     Слушаем в фазе перехвата и глушим событие до обработчика темы. */
  document.addEventListener(
    'keyup',
    function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      if (!anyPanelOpen()) return;
      event.stopPropagation();
      closeAllPanels();
    },
    true
  );

  /* Пользователь меняет город/отделение — обновляем подпись на кнопке.
     Виджет «Нова пошта» заполняет поля программно при выборе из списка,
     поэтому слушаем и click тоже. */
  ['change', 'input', 'click'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        if (!event.target.closest || !event.target.closest('#nova-poshta')) return;
        setTimeout(syncDeliverySummary, 60);
      },
      true
    );
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDeliverySummary);
  } else {
    syncDeliverySummary();
  }

  /* Наружу — для nova-poshta.liquid: по клику на «Оформити замовлення»
     без выбранного отделения он открывает вкладку «Доставка». */
  window.cartDrawerPanels = {
    open: openPanel,
    close: closeAllPanels,
    syncDelivery: syncDeliverySummary
  };
})();
